import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#0062A9',
      light: '#2897D4',
      dark: '#0062A9',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2CB9EE',
      light: '#6CD1F7',
      dark: '#2CB9EE',
      contrastText: '#000000',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
    },
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 17,
    fontWeightRegular: 400,
    fontWeightMedium: 400,
    button: {
      textTransform: 'none',
      fontWeight: 400,
    },
    h6: {
      fontWeight: 400,
      fontSize: '1.125rem',
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          colorScheme: 'light',
        },
        body: {
          color: '#000000',
          background: '#ffffff',
          fontSize: 17,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#ffffff',
          color: '#000000',
          boxShadow: 'none',
          border: '1px solid rgba(0, 0, 0, 0.12)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          fontWeight: 400,
        },
        contained: {
          backgroundColor: '#2CB9EE',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#6CD1F7',
          },
        },
        outlined: {
          borderColor: '#2CB9EE',
          color: '#0062A9',
          '&:hover': {
            backgroundColor: 'rgba(44, 185, 238, 0.08)',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#000000',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#ffffff',
          border: '1px solid rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
})

export default theme